/* eslint-disable no-console */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import Button from "../../../../Core/Components/CustomButton";
import UnRetireIcon from "../../../../Common/Svgs/UnRetireIcon";
import { getFarmersV3, unretireFarmer } from "../../../../Redux/APIs/usersAPI";
import { updateUsers } from "../../../../Redux/Slices/users.slice";
import { DEFAULT_LIMIT } from "../../../../Utils/constants";

const UnretireFarmerModal = ({
  visible,
  onCancel,
  farmersCurrentPage,
  setFarmersCurrentPage,
  pageSize = DEFAULT_LIMIT,
  filters = {},
}) => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);

  const { unretireFarmerModal } = useSelector((state) => state.users);

  const onConfirm = async () => {
    try {
      setBtnLoading(true);
      await dispatch(
        unretireFarmer({ farmerId: unretireFarmerModal.id }),
      ).unwrap();

      const filterObj = {
        offset: ((farmersCurrentPage || 1) - 1) * pageSize,
        limit: pageSize,
      };

      if (filters.hub?.length) filterObj.hub = filters.hub;
      if (filters.collectionPoint?.length) {
        filterObj.collectionPoint = filters.collectionPoint;
      }
      if (filters.retired !== undefined) filterObj.retired = filters.retired;
      if (filters.farmerSelected?.length) {
        filterObj.farmerSelected = filters.farmerSelected;
      }
      if (filters.dateRangeStart && filters.dateRangeEnd) {
        filterObj.dateRangeStart = filters.dateRangeStart;
        filterObj.dateRangeEnd = filters.dateRangeEnd;
      }

      const response = await dispatch(getFarmersV3(filterObj));

      if (!response?.payload?.result?.length && farmersCurrentPage > 1) {
        const previousPage = farmersCurrentPage - 1;
        setFarmersCurrentPage(previousPage);
        filterObj.offset = (previousPage - 1) * pageSize;
        await dispatch(getFarmersV3(filterObj));
      }

      dispatch(
        updateUsers({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "1 farmer re-instated",
              description: `${
                unretireFarmerModal?.name || "1 farmer"
              } was re-instated successfully.`,
            },
          },
        }),
      );

      onCancel();
    } catch (error) {
      console.error(error);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="relative">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<UnRetireIcon size={24} className="text-white" />}
              background="bg-primary"
            />
          </div>
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-black font-poppins">
            Re-instate farmer
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            Are you sure you want to re-instate this farmer?
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            colors="primary"
            size="primary"
            onClick={onConfirm}
            disabled={btnLoading}
          >
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UnretireFarmerModal;
